/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import "./Realtorsandbrokerages.css";
import buildingimage from "../../images/building-bg.png";
import buildingimagesecond from "../../images/building-bg-right.png";
import linedcircle from "../../images/lined-circle.png";
import circleleft from "../../images/circle-left-bg.png";
import circleright from "../../images/circle-right-bg.png";
import FooterComponent from "../../Pages/Footer/Footer";
import HeaderComponent from "../../Pages/Header/Header";
import compliance from "../../images/compliance.svg";
import public_security from "../../images/publickey.svg";
import share_img from "../../images/secure.svg";
import claim_community from "../../images/claimacommunity.png";
import community_info from "../../images/communityinformation.png";
import community_profile from "../../images/communityprofile.png";
import exclusive_realtor from "../../images/exclusiverealtor.png";
import realtor_collage from "../../images/realtorsbg.png";
import { useNavigate } from "react-router-dom";
function RealtorsBrokerages() {
  const navigate = useNavigate()
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top
  }, []);
  return (
    <>
      <HeaderComponent />
      <section className="one hoa-page-section">
        <div className="container">
          {/* <HeaderComponent /> */}
          <div className="banner-content">
            <h1 className="text-center m-0 title-main">
              Realtors & Brokerages
            </h1>
            <p className="text-center hoa-subtitle">
              Streamline Community Access and Boost Real Estate Leads
            </p>
            <div className="hz-line"></div>
          </div>
        </div>
        <div className="building-block-left">
          <img src={buildingimage} alt="building-pic"></img>
        </div>
        <div className="building-block-right">
          <img src={buildingimagesecond} alt="building-pic"></img>
        </div>
      </section>
      <section className="two text-center hoa-section-two realtors-brokerages-section">
        <div className="container">
          <div className="streamline-content">
            <h2>Unlock a New Era of Real Estate with HOA Verified</h2>
            <p className="text-center hoa-subtitle mt-4">
              Are you ready to revolutionize the way you connect with
              communities and close more deals? HOA Verified is your key to
              unparalleled access, transparency, and influence in the
              home-buying process.
            </p>
            <div className="circle-left">
              <img src={circleleft} alt="circle-img"></img>
            </div>
          </div>
          <div className="row mt-5 hoa-verified-row">
            <div className="col-md-6">
              <h2 className="text-start mb-4">What is HOA Verified?</h2>
              <p className="hoa-verified-info text-start">
                HOA Verified helps homeowner associations comply with Florida
                mandates by providing a secure, free document and communication
                portal for their residents. The platform offers a public-facing
                page that assists Realtors and non-residents in exploring new
                communities, accessing rules and regulations, applications, and
                reading authentic reviews from current residents.
              </p>
              <p className="text-box text-start">
                As the exclusive Realtor, visitors to this public-facing
                platform will be routed directly to your real estate website,
                driving more traffic and generating potential leads.
              </p>
              <div className="text-start mt-5">
                <button className="btn btn-outline get-started" type="submit" onClick={() => navigate("/signupone")}>
                  Get Started{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="#222222"
                  >
                    <path d="M13.3364 7.84518L6.16426 15.0173L4.98575 13.8388L12.1579 6.66667H5.83643V5H15.0031V14.1667H13.3364V7.84518Z"></path>
                  </svg>
                </button>
              </div>
            </div>
            <div className="col-md-6">
              <div className="collage_img_block position-relative">
                <div className="collage_img position-relative">
                  <img src={realtor_collage} alt="collage-image"></img>
                </div>
                <div className="circle-right-hoa">
                  <img src={circleright} alt="circle-img"></img>
                </div>
                <div className="circle-left-hoa">
                  <img src={linedcircle} alt="circle-img"></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="two text-center hoa-section-two">
        <div className="container">
          <div className="streamline-content-lower-block">
            <h2>Become the Exclusive Realtor for Your Community</h2>
            <p className="text-center exclusive-realtor-para mt-4">
              As the exclusive Realtor on HOA Verified, you'll have the
              opportunity to increase your visibility and generate more leads.
              Visitors to the platform will be directed straight to your real
              estate website, driving traffic and connecting you with potential
              buyers. Showcase your expertise in the communities you specialize
              in, and let HOA Verified do the work of routing interested
              prospects directly to you.
            </p>
          </div>
        </div>
      </section>
      <section className="four hoa-section-four">
        <div className="container">
          <div className="document-block">
            <div className="doc-inner-block">
              <div className="box">
                <div className="box-inner text-center">
                  <img src={compliance} alt="compliance_img"></img>
                  <span>Boost Lead Generation</span>
                  <p>
                    All prospective homebuyers will be directed to your website,
                    enhancing your visibility and lead potential.
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="box-inner text-center">
                  <img src={share_img} alt="share"></img>
                  <span>Streamlined Information</span>
                  <p>
                    Share a single link with clients to provide access to
                    everything they need about the community.
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="box-inner text-center">
                  <img src={public_security} alt="public-key"></img>
                  <span>Exclusive Access</span>
                  <p>
                    Claim the communities you specialize in and stand out as the
                    go-to Realtor.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </section>
      <section className="six hoa-six-section">
        <div className="container">
          <div className="free-trial-box text-center">
            <h2>Get Started</h2>
            <p className="lawsuit-para mb-5">
              Become the Community Real Estate Specialist in your area for FREE!
              We make money on vendor advertisements allowing associations and
              realtors to utilize the platform at no cost. Start generating new
              leads today!
            </p>
            <div className="button-area d-flex justify-content-center">
              <button
                className="btn btn-outline contact-us mt-3 mb-2"
                type="submit"
                onClick={() => navigate("/Contact")}
              >
                Contact us{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#222222"
                >
                  <g id="arrow-right-up-line">
                    <path
                      id="Vector"
                      d="M13.9137 10.7054L3.77688 11.0594L3.71871 9.39376L13.8555 9.03977L9.23227 4.72853L10.3689 3.50961L17.073 9.76124L10.8213 16.4653L9.60241 15.3287L13.9137 10.7054Z"
                      fill=""
                    ></path>
                  </g>
                </svg>
              </button>
              <button
                className="btn btn-outline get-started-trail mt-3 mb-2"
                type="submit"
                onClick={() => navigate("/signupone")}
              >
                Get Started{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#ffffff"
                >
                  <path d="M13.3364 7.84518L6.16426 15.0173L4.98575 13.8388L12.1579 6.66667H5.83643V5H15.0031V14.1667H13.3364V7.84518Z"></path>
                </svg>
              </button>
            </div>
          </div>
          <div className="half-circle-hoa">
            <img src={linedcircle} alt="circle-img"></img>
          </div>
        </div>

        {/* <div className="building-bg-area">
                    <img src={buildingleft} alt="building"></img>
                </div> */}
      </section>
      <section className="vertical-tabs-section">
        <div className="container">
          <h2 className="vertical-tab-heading">How it Works</h2>
          <div className="d-flex align-items-start vertical-tabs">
            <div
              className="nav flex-column nav-pills me-3 vertical-left-block"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                className="nav-link active"
                id="v-pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-home"
                type=""
                role="tab"
                aria-controls="v-pills-home"
                aria-selected="true"
              >
                Claim A Community
              </a>
              <a
                className="nav-link"
                id="v-pills-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-profile"
                type=""
                role="tab"
                aria-controls="v-pills-profile"
                aria-selected="false"
              >
                Community Information
              </a>
              <a
                className="nav-link"
                id="v-pills-messages-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-messages"
                type=""
                role="tab"
                aria-controls="v-pills-messages"
                aria-selected="false"
              >
                Community Profile
              </a>
              <a
                className="nav-link"
                id="v-pills-settings-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-settings"
                type=""
                role="tab"
                aria-controls="v-pills-settings"
                aria-selected="false"
              >
                Exclusive Realtor
              </a>
            </div>
            <div className="tab-content" id="v-pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
                tabIndex="0"
              >
                <div className="benefits-block">
                  <div className="benefits-inner-block">
                    <div className="benefits-inner-wrapper d-flex flex-column">
                      <div className="portal_img">
                        <img
                          src={claim_community}
                          alt="residemt-portal-img"
                        ></img>
                      </div>
                      <h3 className="portal-title">Claim a Community</h3>
                      <div className="portal-info">
                        Select the communities you specialize in to become the
                        exclusive Realtor.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-profile"
                role="tabpanel"
                aria-labelledby="v-pills-profile-tab"
                tabIndex="0"
              >
                <div className="benefits-block">
                  <div className="benefits-inner-block">
                    <div className="benefits-inner-wrapper d-flex flex-column">
                      <div className="portal_img">
                        <img
                          src={community_info}
                          alt="public-sharing-img"
                        ></img>
                      </div>
                      <h3 className="portal-title">Community Information</h3>
                      <div className="portal-info">
                        Save time on organizing community information. Simply
                        share a link with client. Everything you need is on HOA
                        Verified.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-messages"
                role="tabpanel"
                aria-labelledby="v-pills-messages-tab"
                tabIndex="0"
              >
                <div className="benefits-block">
                  <div className="benefits-inner-block">
                    <div className="benefits-inner-wrapper d-flex flex-column">
                      <div className="portal_img">
                        <img src={community_profile} alt="compliance-img"></img>
                      </div>
                      <h3 className="portal-title">Community Profile</h3>
                      <div className="portal-info">
                        As the exclusive Realtor, you will be responsible for
                        setting up and maintaining only the public-facing page,
                        which takes about 10 minutes. If the association
                        subscribes to the platform, only your Realtor website
                        links will be needed.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-settings"
                role="tabpanel"
                aria-labelledby="v-pills-settings-tab"
                tabIndex="0"
              >
                <div className="benefits-block">
                  <div className="benefits-inner-block">
                    <div className="benefits-inner-wrapper d-flex flex-column">
                      <div className="portal_img">
                        <img
                          src={exclusive_realtor}
                          alt="man-burdened-img"
                        ></img>
                      </div>
                      <h3 className="portal-title">Exclusive Realtor</h3>
                      <div className="portal-info">
                        Prospective home buyers are directed to your website,
                        increasing leads and visibility.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterComponent />
    </>
  );
}

export default RealtorsBrokerages;
